import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ChiSiamo from './components/ChiSiamo';
import Servizi from './components/Servizi';
import Recensioni from './components/Recensioni';
import Contatti from './components/Contatti';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';

export default function Home() {
  return (
    <div className="font-sans antialiased">
      <Navbar />
      <main>
        <Hero />
        <ChiSiamo />
        <Servizi />
        <Recensioni />
        <Contatti />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
